import { zodFallback } from '../../zod/fallback';
import { zodForgivingSchema } from '../../zod/forgivingSchema';
import z from 'zod';

export const InfoMaterialStoreFlag = zodFallback(z.enum(['light', 'premium', 'mixed']), 'unknown');
export type InfoMaterialStoreFlag = z.infer<typeof InfoMaterialStoreFlag>;

export const InfoMaterial = zodForgivingSchema(
    z.object({
        id: z.string(),
        mainLanguage: z.string(),
        titles: z.record(z.string(), z.string()),
        urls: z.record(z.string(), z.string()),
        storeFlags: InfoMaterialStoreFlag.array(),
        orderIndex: z.int(),
        createdBy: z.string(),
        createdOn: z.coerce.date(),
        modifiedBy: z.string(),
        modifiedOn: z.coerce.date(),
    }),
);
export type InfoMaterial = z.infer<typeof InfoMaterial>;

export const InfoMaterialCreateModel = zodForgivingSchema(
    InfoMaterial.unwrap().omit({
        id: true,
        createdBy: true,
        createdOn: true,
        modifiedBy: true,
        modifiedOn: true,
    }),
);
export type InfoMaterialCreateModel = z.infer<typeof InfoMaterialCreateModel>;

export const InfoMaterialUpdateModel = zodForgivingSchema(InfoMaterialCreateModel.unwrap().partial());
export type InfoMaterialUpdateModel = z.infer<typeof InfoMaterialUpdateModel>;
